import i18next from 'i18next';
import { useEffect } from 'react';
import { convertDetectedLanguage } from '~/components/I18n';
import { useSetting } from '~/components/Setting/Setting.hooks';

export const LanguageObserver = () => {
  const { data, isFetched } = useSetting();

  useEffect(() => {
    if (isFetched && data?.language && i18next.resolvedLanguage !== data.language) {
      i18next.changeLanguage(convertDetectedLanguage(data.language));
    }
  }, [data, isFetched]);

  return null;
};
